import type { InternalToolsMenu } from './types';

const DEFAULT_INTERNAL_TOOLS_MENU: InternalToolsMenu = {
  'feature-flag-override': {
    value: false,
    label: 'Feature Flag Override',
    tooltip: 'Override feature flags for testing purposes.',
  },
};

export { DEFAULT_INTERNAL_TOOLS_MENU };
